import React from 'react';
import { motion } from 'framer-motion';
import { SectionTag } from './SectionTag';
import { INSIDE_CLOSER, INSIDE_COMPOSITION, INSIDE_LEAD, INSIDE_TAGS } from './salesData';

/**
 * Demostración del valor real del producto antes de bonos y precio.
 * Composición editorial de previews reales del interior del sistema:
 * páginas superpuestas con ángulos mínimos, sombras suaves y profundidad.
 */
export function InsideSection() {
  return <section id="por-dentro" className="bg-bone py-14 sm:py-24" aria-labelledby="inside-title" data-id="element-132" data-mp="39zdve8naxhgb">
      <div className="mx-auto w-full max-w-6xl px-4 sm:px-8" data-id="element-133" data-mp="3f1l9b3roz7la">
        <div className="max-w-2xl" data-id="element-134" data-mp="3110qi7ls1brs">
          <SectionTag data-id="element-135" data-mp="311tskv9sjd3l">Por dentro</SectionTag>
          <h2 id="inside-title" className="mt-4 font-display text-[1.6rem] uppercase leading-[1.06] text-charcoal sm:text-[2.5rem]" data-id="element-136" data-mp="35z280o3k1315">
            Mirá todo lo que tenés en tus manos
          </h2>
          <p className="mt-4 font-sans text-[0.88rem] leading-relaxed text-charcoal/65 sm:text-base" data-id="element-137" data-mp="146xlxt8qkzyc">
            {INSIDE_LEAD}
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 18
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.32,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative mt-8 aspect-[4/5] w-full sm:mt-12 sm:aspect-[16/9]" data-id="element-138" data-mp="2vugaue6ykhc0">
          {INSIDE_COMPOSITION.map((piece, index) => <figure key={piece.image} className={`absolute overflow-hidden rounded-lg border border-warm bg-ivory shadow-[0_20px_44px_-20px_rgba(34,34,34,0.35)] sm:rounded-xl ${piece.className}`} data-id="element-139" data-mp="2gxh5yy3hr2l8" data-mpi={index}>
              <img src={piece.image} alt={piece.alt} loading={index === 0 ? 'eager' : 'lazy'} decoding="async" className="w-full object-cover" data-id="element-140" data-mp="2lwk6c58j0kmv" />
            </figure>)}
        </motion.div>

        <div className="mt-8 rounded-3xl border border-warm bg-ivory p-5 sm:mt-12 sm:p-8" data-id="element-141" data-mp="9711564tm4m2">
          <ul className="flex flex-wrap gap-2 sm:gap-2.5" data-id="element-142" data-mp="d8cgmitzd9gj">
            {INSIDE_TAGS.map(tag => <li key={tag} className="rounded-full bg-gold-pale px-3.5 py-2 font-sans text-[0.64rem] font-bold uppercase tracking-[0.1em] text-charcoal/80 sm:text-[0.72rem]" data-id="element-143" data-mp="i7fmu6lp5lq3">
                {tag}
              </li>)}
          </ul>
          <p className="mt-6 border-t border-warm pt-5 font-display text-[1.05rem] uppercase leading-tight text-charcoal sm:text-[1.4rem]" data-id="element-144" data-mp="3qn8t7smbdgtf">
            {INSIDE_CLOSER}
          </p>
        </div>
      </div>
    </section>;
}